/* @ngInject */
const commande = (
  commandeAsk,
  commandeGo,
  commandeLocal,
  commandeData,
  commandeFormat,
  commandeMetadata,
  commandeRequest
) => {
  const self = {}

  self.new = () => {
    return {
      name: null,
    }
  }

  self.go = commandeGo
  self.local = commandeLocal
  self.format = commandeFormat
  self.metadata = commandeMetadata
  self.data = commandeData
  self.ask = commandeAsk
  self.request = commandeRequest

  return self
}

export default commande



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/services/commande.service.js